import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGet } from '../../services';

export const fetchSliderGet = createAsyncThunk(
    'sliderGet/fetchSliderGet',
    async ({ id }) => {
        const response = await SliderGet(id)
        return response.result
    }
);

const sliderGetSlice = createSlice({
    name: 'sliderGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGetSlice.reducer;
